import mock from "../mock"
export let rolesList = [
  {
    id: 1,
    active_status: true,
    name: "Administrator",
    departments : [
      "Reservation", "House Keeping", "Accounts", "Land Trasportation"
    ],
    desc: "Lorem ipsum doler sit amith"
  },
  {
    id: 2,
    active_status: false,
    name: "Supervisor",
    departments : [
      "Accounts", "Land Trasportation"
    ],
    desc: "Lorem ipsum doler sit amith"
  },
  {
    id: 3,
    active_status: true,
    name: "Manager",
    departments : [
      "Accounts",
    ],
    desc: "Lorem ipsum doler sit amith"
  },
  {
    id: 4,
    active_status: false,
    name: "Staff",
    departments : [
      "Reservation", "Reception"
    ],
    desc: "Lorem ipsum doler sit amith"
  },
  {
    id: 5,
    active_status: true,
    name: "Driver",
    departments : [
      "Land Transportation", "Boat Transportation"
    ],
    desc: "Lorem ipsum doler sit amith"
  },
  {
    id: 6,
    active_status: false,
    name: "Diving Instructor",
    departments : [
      "Diving",
    ],
    desc: "Lorem ipsum doler sit amith"
  },
  {
    id: 7,
    active_status: true,
    name: "Diving Master",
    departments : [
      "Diving",
    ],
    desc: "Lorem ipsum doler sit amith"
  },
  {
    id: 8,
    active_status: false,
    name: "Customer",
    departments : [
      "Booking", "General",
    ],
    desc: "Lorem ipsum doler sit amith"
  },
  {
    id: 9,
    active_status: true,
    name: "Travel Agent Admin",
    departments : [
      "Booking", 
    ],
    desc: "Lorem ipsum doler sit amith"
  },
  {
    id: 10,
    active_status: false,
    name: "Travel Agent Staff",
    departments : [
      "Booking",
    ],
    desc: "Lorem ipsum doler sit amith"
  },
]

// GET DATA
mock.onGet("/api/rolesList/initial-data").reply(response => { 
  return [200, rolesList]
})

mock.onGet("/api/rolesList/data").reply(response => {
  let { page, perPage } = response  
  let totalPages = Math.ceil(rolesList.length / perPage)
  if (page !== undefined && perPage !== undefined) {
    let calculatedPage = (page - 1) * perPage    
    let calculatedPerPage = page * perPage
    return [
      200,
      { data: rolesList.slice(calculatedPage, calculatedPerPage), totalPages }
    ]
  } else {
    return [
      200,
      { data: rolesList.slice(0, 10), totalPages: Math.ceil(rolesList.length / 10) }
    ]
  }
})

// UPDATE DATA
mock.onPost("/api/rolesList/update-data").reply(request => {
  //let data = JSON.parse(request.data).obj
  rolesList.map(item => {
    return item    
  })
  return [200]
})

// Add DATA
mock.onPost("/api/rolesList/add-data").reply(request => {
  let data = JSON.parse(request.data).obj
  let highestId = Math.max.apply(
    Math,
    rolesList.map(i => i.id)
  )
  rolesList.unshift({
    ...data,
    id: highestId + 1,
    
  })
  return [200]
})

// DELETE DATA
mock.onPost("/api/rolesList/delete-data").reply(request => {
  let data = JSON.parse(request.data).obj
  let index = rolesList.findIndex(item => item.id === data.id)
  rolesList.splice(index, 1)
  return [200]
})

// DELETE SELECTED DATA
mock.onPost("/api/rolesList/delete-selected").reply(request => {
  let data = JSON.parse(request.data).arr
  let reducedArray
  ;[rolesList, data].reduce((a, b) => {
    let c = b.map(j => j.id)
    return (reducedArray = a.filter(i => !c.includes(i.id)))
  })
  rolesList = reducedArray
  return [200]
})
